module.exports = __webpack_public_path__ + "ph.svg?8177a4f5e0841e9431e3a11312b0a34a";